import { Box, Loader, Select, Text } from "@mantine/core"
import { useDebouncedCallback } from "@mantine/hooks"
import { useEffect, useState } from "react"
import { getAllBrandList } from "../../../services/brands"

const InputBrandActionBanner = ({ dataBrandIds, onChange, isError }) => {
  const [brandId, setBrandId] = useState(null)

  const [brandList, setBrandList] = useState([])
  const [loadingBrand, setLoadingBrand] = useState(true)
  const [searchBrand, setSearchBrand] = useState('')

  const handelGetListBrand = useDebouncedCallback(async (supplierId) => {
    setLoadingBrand(true)
    const parameter = {
      'filter[id][is]': supplierId,
      'filter[name][like]': searchBrand,
      'page[num]': 1,
      'page[limit]': 10, // bad habbit
    }

    try {
      const response = await getAllBrandList(parameter)
      const dataBrands = response.data
      const remapDataBrands = dataBrands.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setBrandList(remapDataBrands)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingBrand(false)
    }
  }, 300)

  useEffect(() => {
    const initialBrandId = dataBrandIds[0] || null
    setBrandId(initialBrandId)

    if (initialBrandId) {
      handelGetListBrand(initialBrandId)
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    handelGetListBrand()
    // eslint-disable-next-line
  }, [searchBrand])


  const handleChage = (val) => {
    setBrandId(val)
    onChange(val)
  }

  const loadingDataTemplate = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }

  return (
    <Select
      name='input_brand_banner'
      label='Brand'
      value={brandId}
      data={brandList}
      onChange={(val) => handleChage(val)}
      size='xs'
      searchable
      searchValue={searchBrand}
      error={isError && 'Brand is Required'}
      onSearchChange={setSearchBrand}
      nothingFoundMessage={!loadingBrand ? brandList.length > 0 ? '' : 'No Brand Found' : loadingDataTemplate()}
      clearable
    />
  )
}

export default InputBrandActionBanner